import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.75, ease: EASE } },
};

export const stagger = {
    hidden: {},
    show: { transition: { staggerChildren: 0.09 } },
};

export default function Reveal({ children, delay = 0, className, y = 30 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.75, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export { EASE };
